import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import about1 from "../assets/Digital lifestyle-amico.png";
import about2 from "../assets/Marketing consulting-amico.png";

const STATS = [
  { value: 80, label: "Projects Completed" },
  { value: 40, label: "Happy Clients" },
  { value: 10, label: "Years Experience" },
  { value: 100, label: "Campaigns" },
];

function About() {
  const statsRef = useRef([]);
  const sectionRef = useRef();

  /* scroll-anim observer */
  useEffect(() => {
    const els = sectionRef.current?.querySelectorAll(".scroll-anim") || [];
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add("show"); }),
      { threshold: 0.15 }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  /* counter animation */
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          const target = +el.getAttribute("data-target");
          let count = 0;
          const tick = () => {
            count += target / 80;
            if (count < target) { el.innerText = Math.ceil(count) + "+"; requestAnimationFrame(tick); }
            else el.innerText = target + "+";
          };
          tick();
          obs.unobserve(el);
        });
      },
      { threshold: 0.6 }
    );
    statsRef.current.forEach((el) => el && obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <section id="about" className="about" ref={sectionRef}>

      <div className="about-header scroll-anim">
        <p className="about-sub">— About Us —</p>
        <h2>Helping Businesses Grow Through Strategic Digital Marketing</h2>
      </div>

      <div className="about-container">

        {/* LEFT TEXT */}
        <div className="about-left scroll-anim">
          <p>
            At PD Marketz, we help businesses grow their digital presence through strategic and
            performance-driven marketing. Our focus is on building marketing systems that attract
            the right audience, generate qualified leads, and support long-term business growth.
          </p>
          <p>
            With over a decade of industry experience, our team works closely with startups and
            growing brands to create practical marketing strategies that deliver measurable results.
          </p>
          <Link to="/about" className="about-btn">More About Us →</Link>
        </div>

        {/* IMAGES */}
        <div className="about-images">
          <motion.div
            className="about-img-wrap about-img-wrap--left scroll-anim"
            initial={{ opacity: 0, x: -30, rotate: -4 }}
            whileInView={{ opacity: 1, x: 0, rotate: -4 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8 }}
          >
            <img src={about1} alt="team" />
          </motion.div>

          <motion.div
            className="about-img-wrap about-img-wrap--right scroll-anim delay"
            initial={{ opacity: 0, x: 30, rotate: 4 }}
            whileInView={{ opacity: 1, x: 0, rotate: 4 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8, delay: 0.1 }}
          >
            <img src={about2} alt="team" />
          </motion.div>

          <motion.div
            className="about-badge scroll-anim delay2"
            initial={{ opacity: 0, scale: 0.7 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <span>Driving</span>
            <span>Digital Growth</span>
          </motion.div>
        </div>

        {/* STATS */}
        <div className="about-right scroll-anim delay3">
          {STATS.map((s, i) => (
            <div className="stat" key={s.label}>
              <h3 ref={(el) => (statsRef.current[i] = el)} data-target={s.value}>0</h3>
              <p>{s.label}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default About;
